package com.mrpowergamerbr.puppydough

import js.iterable.asFlow
import jszip.Compression
import jszip.DEFLATE
import jszip.JSZip
import jszip.JSZipGeneratorOptions
import jszip.JSZipObject
import jszip.OutputType
import jszip.arrayBuffer
import jszip.blob
import jszip.generate
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.async
import kotlinx.coroutines.awaitAll
import kotlinx.coroutines.sync.Semaphore
import kotlinx.coroutines.sync.withPermit
import web.blob.arrayBuffer
import web.file.File
import web.fs.FileSystemDirectoryHandle
import web.fs.FileSystemFileHandle
import web.fs.FileSystemGetDirectoryOptions
import web.fs.FileSystemGetFileOptions
import web.fs.createWritable
import web.fs.getDirectoryHandle
import web.fs.getFile
import web.fs.getFileHandle
import web.fs.write
import web.navigator.navigator
import web.storage.getDirectory
import web.streams.close
import web.streams.pipeTo
import web.url.URL

object OPFSUtils {
    suspend fun getDirectoryNestedHandleCreateIfDoesNotExist(path: String, baseDirectory: FileSystemDirectoryHandle): FileSystemDirectoryHandle {
        val elements = path.removeSuffix("/").split("/")
        var handle = baseDirectory

        for (element in elements)
            handle = handle.getDirectoryHandle(element, FileSystemGetDirectoryOptions.Companion(create = true))

        return handle
    }

    suspend fun getFileNestedHandleCreateIfDoesNotExist(path: String, baseDirectory: FileSystemDirectoryHandle): FileSystemFileHandle {
        val elements = path.split("/")
        var handle = baseDirectory

        for (element in elements.dropLast(1))
            handle = handle.getDirectoryHandle(element, FileSystemGetDirectoryOptions.Companion(create = true))

        return handle.getFileHandle(elements.last(), FileSystemGetFileOptions.Companion(create = true))
    }

    suspend fun getFileNestedHandle(path: String, baseDirectory: FileSystemDirectoryHandle): FileSystemFileHandle? {
        val elements = path.split("/")
        var handle = baseDirectory

        try {
            for (element in elements.dropLast(1))
                handle = handle.getDirectoryHandle(element, FileSystemGetDirectoryOptions.Companion(create = false))

            return handle.getFileHandle(elements.last(), FileSystemGetFileOptions.Companion(create = false))
        } catch (e: Throwable) {
            e.printStackTrace()
            return null
        }
    }

    suspend fun copyFilesToOPFS(targetFolder: String, files: List<File>, callback: (String, Int) -> (Unit)) {
        val directory = navigator.storage.getDirectory()
        val bundleDirectory = getDirectoryNestedHandleCreateIfDoesNotExist(targetFolder, directory)

        val semaphore = Semaphore(8)
        var count = 0
        val jobs = files.map { file ->
            GlobalScope.async {
                semaphore.withPermit {
                    val handle = OPFSUtils.getFileNestedHandleCreateIfDoesNotExist(file.webkitRelativePath.substringAfter("/"), bundleDirectory)
                    callback(handle.name, count++)
                    val writable = handle.createWritable()
                    file.stream().pipeTo(writable)
                }
            }
        }
        jobs.awaitAll()
    }

    suspend fun compressFolderToZIP(targetFolder: String): String {
        val savesDirectory = getDirectoryNestedHandleCreateIfDoesNotExist(targetFolder, navigator.storage.getDirectory())
        val zip = JSZip()
        savesDirectory.values().asFlow().collect {
            if (it is FileSystemFileHandle) {
                println(it.name)
                val arrayBuffer = it.getFile().arrayBuffer()
                zip.file(it.name, arrayBuffer)
            }
        }
        val blob = zip.generate(JSZipGeneratorOptions(type = OutputType.blob, compression = Compression.DEFLATE))
        return URL.createObjectURL(blob)
    }

    suspend fun extractZIPToFolder(targetFolder: String, zip: JSZip) {
        val savesDirectory = getDirectoryNestedHandleCreateIfDoesNotExist(targetFolder, navigator.storage.getDirectory())
        val entries = mutableListOf<JSZipObject>()
        zip.forEach { _, entry ->
            if (!entry.dir)
                entries.add(entry)
        }

        for (entry in entries) {
            // Saves are stored flat, so only the file name is kept (this also avoids zip slip)
            val name = entry.name.substringAfterLast('/')
            println(name)
            val f = savesDirectory.getFileHandle(name, FileSystemGetFileOptions(create = true))
            val writable = f.createWritable()
            writable.write(entry.arrayBuffer())
            writable.close()
        }
    }
}